import Head from 'next/head';

import WelcomeHero from '@components/funnel-welcome/WelcomeHero';
import MiniLeaguePromiseSection from '@components/funnel-welcome/MiniLeaguePromiseSection';
import AppDownloadSection from '@components/funnel-welcome/AppDownloadSection';
import ReturnToHubLink from '@components/funnel-welcome/ReturnToHubLink';
import { WEBSITE_NAME } from '@lib/constants';

/**
 * The funnel's post-checkout landing (FFH-1533/FFH-1597). Stripe returns
 * checkouts to /thank-you, which fires the purchase analytics, force-
 * refreshes the Auth0 token (re-running the post-login Action so the new
 * subscription claim is minted without logging the user out), and then
 * redirects here — so visitors arrive authenticated, capture their
 * Mini-League Promise, and explore the app download options.
 *
 * The mini-league capture sits between the hero and the app download
 * section (FFH-1076): capture must come before the app-install handoff,
 * because a user who leaves for the App Store is lost from the web flow.
 */
const FunnelWelcome = () => (
  <div className="min-h-screen bg-neutral-100">
    <Head>
      <title>{`Welcome | ${WEBSITE_NAME}`}</title>
      <meta name="robots" content="noindex,nofollow" />
    </Head>
    <main className="mx-auto w-full max-w-md px-6 pb-16">
      <WelcomeHero />
      <MiniLeaguePromiseSection />
      <AppDownloadSection />
      <ReturnToHubLink />
    </main>
  </div>
);

FunnelWelcome.getInitialProps = async () => ({ hideSiteChrome: true });

export default FunnelWelcome;
